// src/components/Navbar.jsx
import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import "../styles/styles.css";

const Navbar = ({ user, onLogout }) => {
  // user es null o { email, role }
  const isCreator = user?.role === "creator";
  // Solo monteroesteban@hotmail.com con rol "admin" tiene permisos de admin
  const isAdmin =
    user?.role === "admin" && user.email === "monteroesteban@hotmail.com";

  return (
    <nav className="navbar">
      {/* Logo */}
      <Link to="/" className="nav-logo">
        <Logo />
        <span className="nav-logo-text">AIVEO</span>
      </Link>

      {/* Tagline */}
      <div className="nav-tagline">Descubre Series Impulsadas por IA</div>

      {/* Enlaces */}
      <div className="nav-links">
        <Link to="/">Inicio</Link>
        <Link to="/movies">Películas</Link>
        <Link to="/creators">IA Creators</Link>
        {/* “Subir Contenido” SOLO para creadores y admin */}
        {(isCreator || isAdmin) && <Link to="/upload">Subir Contenido</Link>}
        {/* Panel Admin solo para monteroesteban@hotmail.com */}
        {isAdmin && (
          <>
            <Link to="/admin/submissions">Panel Pitches</Link>
            <Link to="/admin/users">Gestión Usuarios</Link>
            <Link to="/admin/videos">Gestión Vídeos</Link>
          </>
        )}

        {/* Login/Logout */}
        {user ? (
          <button className="btn-logout" onClick={onLogout}>
            Cerrar sesión
          </button>
        ) : (
          <>
            <Link to="/login">Iniciar sesión</Link>
            <Link to="/register">Registrarse</Link>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
